module.exports = "/cyber/_next/static/images/vesenniiRozygrysh-dd2a31b65fe960d84e82453024814884.jpg";